import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../../../../components/Loader/Loader";
import StandartButton from "../../../../components/StandartButton/StandartButton";
import { Company, Project } from "../../../../types/Company";
import s from "./CompanyPrograms.module.css";
import ProgramCard from "./ProgramCard/ProgramCard";
import ProgramInfo from "./ProgramInfo/ProgramInfo";

type CompanyPrograms = {
  selectedCompany: Company;
  companyProjects: Project[] | null;
  projectsLoader: boolean;
  setCompanyProjects: Dispatch<SetStateAction<Project[] | null>>;
};

const CompanyPrograms = ({
  selectedCompany,
  companyProjects,
  projectsLoader,
  setCompanyProjects,
}: CompanyPrograms) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const programIdFromUrl = searchParams.get("programId");
  const [selectedProgram, setSelectedProgram] = useState<Project | null>(null);
  const companyId = encodeURIComponent(selectedCompany._id);

  useEffect(() => {
    if (!companyProjects) return;

    if (!programIdFromUrl) {
      setSelectedProgram(null);
      return;
    }

    const programFromUrl = companyProjects.find(
      (item) => item._id === programIdFromUrl,
    );

    if (programFromUrl) {
      if (selectedProgram?._id !== programFromUrl._id) {
        setSelectedProgram(programFromUrl);
      }
      return;
    }

    if (!projectsLoader) {
      setSelectedProgram(null);
      const nextSearchParams = new URLSearchParams(searchParams);
      nextSearchParams.delete("programId");
      setSearchParams(nextSearchParams, { replace: true });
    }
  }, [
    companyProjects,
    programIdFromUrl,
    projectsLoader,
    searchParams,
    selectedProgram?._id,
    setSearchParams,
  ]);

  const selectProgramHandler = (program: Project) => {
    setSelectedProgram(program);

    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.set("companyId", selectedCompany._id);
    nextSearchParams.set("tab", "projects");
    nextSearchParams.set("programId", program._id);
    setSearchParams(nextSearchParams);
  };

  const backToProgramsHandler = () => {
    setSelectedProgram(null);

    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.set("companyId", selectedCompany._id);
    nextSearchParams.set("tab", "projects");
    nextSearchParams.delete("programId");
    setSearchParams(nextSearchParams);
  };

  return (
    <div className={s.container}>
      <div
        className={`${s.allProgramsBlock} ${
          selectedProgram ? s.allProgramsBlockHidden : s.allProgramsBlockVisible
        }`}
      >
        <div className={s.actionBlock}>
          <StandartButton
            action={() => navigate(`/companies/${companyId}/projects/new`)}
            buttonTitle="Create Project"
          />
        </div>
        {companyProjects && companyProjects.length ? (
          <div className={s.lableTableBlock}>
            <span>Project title</span>
            <span>Clients</span>
            <span>Specialists</span>
            <span>Discount</span>
            <span>Is private</span>
            <span>End date</span>
          </div>
        ) : null}
        <div className={s.tableBlock}>
          {companyProjects && companyProjects.length ? (
            companyProjects.map((item, index) => (
              <ProgramCard
                index={index}
                programData={item}
                dataLength={companyProjects.length}
                setProgramsData={setCompanyProjects}
                selectedCompany={selectedCompany}
                onSelectProgram={selectProgramHandler}
                key={index}
              />
            ))
          ) : (
            <div className={s.noProgramsBlock}>
              {projectsLoader ? <Loader size={100} /> : <h2>No Projects</h2>}
            </div>
          )}
        </div>
      </div>
      <div
        className={`${s.programInfoBlock} ${
          selectedProgram ? s.programInfoBlockVisible : s.programInfoBlockHidden
        }`}
      >
        {selectedProgram && (
          <ProgramInfo
            selectedProgram={selectedProgram}
            setSelectedProgram={setSelectedProgram}
            onBackToPrograms={backToProgramsHandler}
            companyData={selectedCompany}
          />
        )}
      </div>
    </div>
  );
};

export default CompanyPrograms;
